// @flow

import * as React from 'react';

import { selectGrid } from '@gandi/billing';
import { selectAllCartBundleGrids } from '@gandi/cart';

import { useAppSelector } from 'src/hooks/useAppSelector';
import { selectShopCurrent } from 'src/modules/organization/selectors';

export function useIncompatibleBundleGrid(): {
  hasIncompatibleBundleGrid: boolean,
} {
  const currentOrg = useAppSelector(state => selectShopCurrent(state, true));
  const sharingIdProps = React.useMemo(
    () => ({ sharingId: currentOrg?.id }),
    [currentOrg?.id],
  );
  const grid = useAppSelector(state => selectGrid(state, sharingIdProps));

  const bundleGrids = useAppSelector(selectAllCartBundleGrids);

  const hasIncompatibleBundleGrid =
    Array.isArray(bundleGrids) &&
    bundleGrids.length > 0 &&
    !bundleGrids.includes(grid);

  return {
    hasIncompatibleBundleGrid,
  };
}
